import Link from 'next/link'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { Table, Tbody, Tr, Th, Td } from '@/components/elements/Table'
// import { ZenkakuSpace } from '@/components/pages/Legal/TextStyle'

export const InfoTable = () => {
  return (
    <Table label="株式基本情報">
      <>
        <InfoTableBody>
          <Tr>
            <Th textAlign="left">Fiscal year end</Th>
            <Td textAlign="left">June 30</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">Annual general meeting of shareholders</Th>
            <Td textAlign="left">September</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">Record date for AGM</Th>
            <Td textAlign="left">June 30</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">Record date of the dividend of surplus</Th>
            <Td textAlign="left">
            <p>June 30</p>
            <p>(plus December 31 for interim dividends, if any)</p>
            </Td>
          </Tr>
          <Tr>
            <Th textAlign="left">Number of unit share</Th>
            <Td textAlign="left">100 shares</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">Method of public notice</Th>
            <Td textAlign="left">
              <p>Electronic public notice</p>
              <p>
               If an electronic method is unavailable due to unavoidable reasons, notice shall be via an official public memo (kampo).
              </p>
              <p>
                URL:
                <Link href="/" passHref>
                  <StyledLink>https://trial-holdings.inc</StyledLink>
                </Link>
              </p>
            </Td>
          </Tr>
          <Tr>
            <Th textAlign="left">Stock exchange section</Th>
            <Td textAlign="left">Tokyo Stock Exchange Growth Market</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">IPO</Th>
            <Td textAlign="left">March 21, 2024</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">Securities code</Th>
            <Td textAlign="left">141A</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">
              <p>Administrator of shareholder registry /Transfer account management institution handling special accounts</p>
            </Th>
            <Td textAlign="left"> Mitsubishi UFJ Trust and Banking Corporation</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">Contact</Th>
            <Td textAlign="left">
              <p>Mitsubishi UFJ Trust and Banking Corporation</p>
              <p>Stock Transfer Agency Division</p>
              <br></br>
              <p>Address: J tower, 1-1, Nikkou-cho, Fuchu City, Tokyo, 183-0044 Japan</p>
              <p>PO Box: 29 137-8081</p>
              <p>Phone: 0120-232-711 (Toll free for domestic calls)</p>
            </Td>
          </Tr>
        </InfoTableBody>
      </>
    </Table>
  )
}

const InfoTableBody = styled(Tbody)`
  > tr:first-of-type > th,
  > tr:first-of-type > td {
    border-top: 1px solid ${theme.colors.tableBorder};
  }
`

const StyledLink = styled.a`
  text-decoration: underline;

  &:hover {
    color: ${theme.colors.lightBlue};
  }
`
